import { useTranslation } from 'react-i18next';
import { selectedRoadSectionsQuery } from '../../../../../core/reference/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import { useEffect, useState } from 'react';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ReferenceModalTypes } from '../../../../../core/legacy/reducers/modals';
import { Input } from '../../../../session/list-sessions/styles';
import editRoadSections from '../../../../../core/reference/commands/EditRoadSections';

const EditRoadSectionYearModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedRoadSections = useAppSelector(selectedRoadSectionsQuery);
    const checkedRoadSectionsIds = checkedRoadSections.map((s) => s.id);

    const [year, setYear] = useState<number | null>(null);

    useEffect(() => {
        const years = checkedRoadSections
            .map((rs) => rs.year)
            .filter((n) => n !== undefined)
            .reduce((acc, val) => acc.add(val!), new Set<number>());
        if (years.size === 1) {
            setYear(years.values().next().value as number);
        } else {
            setYear(null);
        }
    }, [checkedRoadSections]);

    const onValidate = () => {
        dispatch(
            editRoadSections({
                roadSectionData: {
                    year,
                },
                roadSectionIds: checkedRoadSectionsIds,
            }),
        );
        setYear(null);
    };

    const handleKeyDown = ({ key }: KeyboardEvent) => {
        if (key === 'Enter') {
            onValidate();
        }
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ReferenceModalTypes.ROAD_SECTION_EDIT_YEAR}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('reference.modals.editYear')}</ModalTitle>
                <Input
                    onKeyDown={handleKeyDown}
                    value={year}
                    type="number"
                    onChange={(e) => setYear(e.target.value === '' ? null : parseInt(e.target.value, 10))}
                    autoFocus
                />
            </ContentContainer>
        </GenericModal>
    );
};

export default EditRoadSectionYearModal;
